export class RepresentanteLegal {
  nome_completo: string;
  rg: string;
  cpf: string;
}
